/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useRef } from 'react';

export default function useCallbackOnce(callback, deps) {
	const isCalled = useRef(false);

	const memoizedCallback = useCallback((...args) => {
		if (isCalled.current) {
			return;
		}

		isCalled.current = true;

		callback(...args);
	}, deps);

	return memoizedCallback;
}
